<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div class="btn-box">
        <button-add :value="'添加'" @click="goToAdd" v-if="permissionCodes.indexOf('041004001') !== -1"/>
        <button-upload :cathUrl="uploadUrl" @getpage="getPage" :onSuccess="onUploadSuccess" value="导入" v-if="permissionCodes.indexOf('041004004') !== -1"/>
      </div>
    </div>
    <table-main :selection="false" :tableHead="tableHead" :tableData="tableData" :total="total" :pageNum="requestData.pageNum" :pageSize="requestData.pageSize" @changePagination="changePagination"  :operationArr="operationArr" @deleteLine="deleteLine" @goToModifyPage="goToModifyPage" @changeSwitch="changeSwitch" tableOperationWidth="160px"/>
  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import ButtonDelete from "../../../components/Button/ButtonDelete";
import ButtonExport from "../../../components/common/buttons/button-export";
import ButtonUpload from "../../../components/common/buttons/button-upload";
import InputSearch from "../../../components/Input/InputSearch";
import InputSelect from "../../../components/Input/InputSelect";
import TableMain from "../../../components/Table/TableMain";
import { api } from "../../api/Group";
import { bus } from "../../../utils/bus";
import { errorHandler } from "../../../utils/errorHandler";
import ButtonAdd from "../../../components/common/buttons/button-add";
import { nSuccess } from "../../../utils/notice";

export default {
  components: {
    ButtonAdd,
    TableMain,
    InputSelect,
    InputSearch,
    ButtonUpload,
    ButtonExport,
    ButtonDelete,
    Breadcrumb
  },
  name: "customer-master-data",
  data() {
    return {
      permissionCodes: "",
      breadcrumb: [
        {
          value: "数据对接",
          name: "customer-master-data"
        },
        {
          value: "场景模板"
        }
      ],
      tableHead: [
        {
          prop: "scenesName",
          label: "场景",
          width: "120"
        },
        {
          prop: "documentType",
          label: "凭证类型",
          width: "120"
        },
        {
          prop: "paymentTerm",
          label: "支付条件",
          width: "120"
        },
        {
          prop: "paymentMethod",
          label: "支付方式",
          width: "120"
        },
        {
          prop: "accountingSubjectNo",
          label: "会计科目号码",
          width: "160"
        },
        {
          prop: "accountingSubjectName",
          label: "会计科目名称(长)",
          width: "240"
        },
        {
          prop: "accountType",
          label: "账户类型",
          width: "120"
        },
        {
          prop: "expenseType",
          label: "费用类型编码",
          width: "120"
        },
        {
          prop: "expenseTypeName",
          label: "费用类型名称",
          width: "120"
        },
        {
          prop: "cashFlowItemCode",
          label: "现金流代码",
          width: "120"
        },
        {
          prop: "cashFlowItemName",
          label: "现金流项目",
          width: "160"
        },
        {
          prop: "isCustomerCode",
          label: "是否传递客户编号",
          isSwitch: true,
          width: "160"
        }
      ],
      tableData: [],
      total: 0,
      operationArr: ["modify", "delete"],
      requestData: {
        searchKey: "",
        pageSize: 10,
        pageNum: 1
      },
      uploadUrl: ""
    };
  },
  created() {
    this.getPage();
    this.uploadUrl = api.importTemplate;
    this.permissionCodes = bus.global.permissionCodes;
  },
  methods: {
    changePagination(data) {
      this.requestData.pageSize = data[1];
      this.requestData.pageNum = data[0];
      this.getPage();
    },
    getPage() {
      this.$axios
        .post(api.getScenesConfigPage, this.requestData)
        .then(res => {
          this.tableData = res.data.data.list;
          this.total = res.data.data.total;
        })
        .catch(errorHandler("获取分页失败"));
    },
    goToAdd() {
      this.$router.push({
        name: "scenario-template-add"
      });
    },
    deleteLine(code) {
      this.$axios
        .post(api.deleteScenesConfig, code)
        .then(res => {
          nSuccess("删除成功");
          this.getPage();
        })
        .catch(errorHandler("删除失败"));
    },
    goToModifyPage(code) {
      let _data = {};
      this.tableData.map(v => {
        if (v.code == code) {
          _data = v;
        }
      });
      this.$router.push({
        name: "scenario-template-modify",
        params: {
          data: _data
        }
      });
    },
    changeSwitch(data) {
      console.log(data);
      this.$confirm("是否确认修改展示客户信息？", "提示")
        .then(() => {
          for (let i in data) {
            if (data[i] === "--") {
              data[i] = "";
            }
          }
          this.$axios
            .post(api.updateScenesConfig, data)
            .then(res => {
              nSuccess("修改成功");
              this.getPage();
            })
            .catch(errorHandler("修改失败"));
          this.getPage();
        })
        .catch(() => {
          this.getPage();
        });
    },
    onUploadSuccess(data) {
      if (data.retCode == 1) {
        nSuccess("导入成功");
        this.pageSize = 10;
        this.pageNum = 1;
        this.getPage();
      } else {
        errorHandler("导入失败")(data);
      }
    }
  }
};
</script>

<style scoped>
.search-line {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}
.btn-box {
  display: flex;
  justify-content: flex-start;
}
</style>



// WEBPACK FOOTER //
// src/view/DataSync/ScenarioTemplate/ScenarioTemplate.vue